import {CouponInfoSheet} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/coupon.types';
import {Product} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/product.types';
import {GetWalletResponse_Tab_Coupons_CouponsHeader} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/wallet/v1/page/service.types';
import {GenericIconName} from '@aboutyou/ui-components';
import React, {MutableRefObject} from 'react';
import styled from 'styled-components';
import {WALLET_HEADER_HEIGHT} from '../../../backend-services/Wallet/deprecated/WalletHeader/WalletTabs';
import {CTA} from './CTA';
import {BodyHeaderSection} from './Components/BodyHeaderSection';
import {HighTierCouponsSection} from './Components/HighTierCouponsSection';
import {COUPON_WALLET_INFO_ICON_CUSTOM_KEY} from './deprecated/highTierWallet/WalletBodyContentView';

export const CouponWalletHeader: React.FC<{
  header: GetWalletResponse_Tab_Coupons_CouponsHeader;
  setSelectedProduct?: (product: Product | undefined) => void;
  paused?: boolean;
  handleCouponInfoClick: (couponInfo?: CouponInfoSheet) => void;
  onCloseInfoSheet: MutableRefObject<VoidFunction | undefined>;
}> = ({
  header,
  setSelectedProduct,
  paused,
  handleCouponInfoClick,
  onCloseInfoSheet,
}) => {
  const fullHeight =
    header.type?.$case === 'couponsPausedSection' ||
    header.type?.$case === 'emptyCouponSection';

  return (
    <HeaderWrapper fullHeight={fullHeight}>
      {header.type?.$case === 'couponsHeaderSection' && (
        <NarrowBodyHeaderSection
          headline={header.type.couponsHeaderSection.headline}
          subline={header.type.couponsHeaderSection.subline}
          iconName={GenericIconName.Coupon}
          darkMode
        />
      )}
      {header.type?.$case === 'couponsPausedSection' && (
        <div>
          <NarrowBodyHeaderSection
            headline={header.type.couponsPausedSection.headline}
            subline={header.type.couponsPausedSection.subline}
            iconName={GenericIconName.PauseRound}
            reduceBottomSpace
            data-testid="emptySection"
            darkMode
          />
          <CTA
            url={header.type.couponsPausedSection.cta.linkTarget.url}
            label={header.type.couponsPausedSection.cta.label}
            isHighTierCTA
            addArrowIcon
            darkMode
          />
        </div>
      )}
      {header.type?.$case === 'emptyCouponSection' && (
        <div>
          <NarrowBodyHeaderSection
            headline={header.type.emptyCouponSection.headline}
            subline={header.type.emptyCouponSection.subline}
            iconName={GenericIconName.Coupon}
            reduceBottomSpace
            data-testid="emptySection"
            darkMode
          />
          <CTA
            url={header.type.emptyCouponSection.cta.linkTarget.url}
            label={header.type.emptyCouponSection.cta.label}
            isHighTierCTA
            addArrowIcon
            darkMode
          />
        </div>
      )}
      {header.type?.$case === 'highTierCouponsSection' && (
        <HighTierCouponsSection
          headline={header.type.highTierCouponsSection.headline}
          coupons={header.type.highTierCouponsSection.coupons}
          handleInfoIconClick={handleCouponInfoClick}
          stateManagerCustomKey={COUPON_WALLET_INFO_ICON_CUSTOM_KEY}
          onCloseInfoSheet={onCloseInfoSheet}
          setSelectedProduct={setSelectedProduct}
          darkMode
          paused={paused}
          makeInert={Boolean(paused)}
        />
      )}
    </HeaderWrapper>
  );
};

const HeaderWrapper = styled.div<{fullHeight?: boolean}>`
  display: flex;
  align-items: center;
  justify-content: center;

  ${props =>
    props.fullHeight &&
    `
    height: calc(100vh - ${WALLET_HEADER_HEIGHT}px);
  `}
`;

const NarrowBodyHeaderSection = styled(BodyHeaderSection)`
  padding-left: 2rem;
  padding-right: 2rem;
`;
